var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row flex-grow-1 chart-wrapper"},[(_vm.hasData)?_c('v-chart',{attrs:{"theme":_vm.theme,"autoresize":"","options":_vm.chartOptions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }